import { render, staticRenderFns } from "./balanceAmount.vue?vue&type=template&id=0379c6be&scoped=true"
import script from "./balanceAmount.vue?vue&type=script&lang=js"
export * from "./balanceAmount.vue?vue&type=script&lang=js"
import style0 from "./balanceAmount.vue?vue&type=style&index=0&id=0379c6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379c6be",
  null
  
)

export default component.exports